import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Header from './Header';
import Hero from './Hero';
import About from './About';
import ServicesMain from './Services';
import Clients from './Clients';
import Contact from './Contact';
import ContactPage from './ContactPage';
import Footer from './Footer';
import AboutPage from './AboutPage';
import ServicesPage from './ServicesPage';
import ProjectsPage from './ProjectsPage';
import NewsPage from './NewsPage';
import PrivacyPolicy from './PrivacyPolicy';
import ComplaintsBook from './ComplaintsBook';
import NotFound from './NotFound';
import CookieConsent from './CookieConsent';
import LegalNotices from './LegalNotices';
import TermsAndConditions from './TermsAndConditions';
import CookiePolicy from './CookiePolicy';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <About />
        <ServicesMain />
        <Clients />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

const AppContent = () => {
  const location = useLocation();

  return (
    <div className="app-container">
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={
            <>
              <Header />
              <main>
                <Hero />
                <About />
                <ServicesMain />
                <Clients />
                <Contact />
              </main>
              <Footer />
            </>
          } />
          <Route path="/nosotros" element={
            <>
              <Header />
              <main>
                <AboutPage />
              </main>
              <Footer />
            </>
          } />
          <Route path="/servicios" element={
            <>
              <Header />
              <main>
                <ServicesPage />
              </main>
              <Footer />
            </>
          } />
          <Route path="/proyectos" element={
            <>
              <Header />
              <main>
                <ProjectsPage />
              </main>
              <Footer />
            </>
          } />
          <Route path="/noticias" element={
            <>
              <Header />
              <main>
                <NewsPage />
              </main>
              <Footer />
            </>
          } />
          <Route path="/clientes" element={
            <>
              <Header />
              <main>
                <Clients />
              </main>
              <Footer />
            </>
          } />
          <Route path="/contacto" element={
            <>
              <Header />
              <main>
                <ContactPage />
              </main>
              <Footer />
            </>
          } />
          <Route path="/avisos-legales" element={<LegalNotices />} />
          <Route path="/privacidad" element={<PrivacyPolicy />} />
          <Route path="/terminos-y-condiciones" element={<TermsAndConditions />} />
          <Route path="/politica-de-cookies" element={<CookiePolicy />} />
          <Route path="/libro-de-reclamaciones" element={<ComplaintsBook />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AnimatePresence>
      <CookieConsent />
    </div>
  );
};

export default AppContent;